<script context="module">

    import { client, gql } from "./GraphQL.svelte";

    const TOKEN_QUERY = gql`
        query {
            me {
                token
            }
        }
    `;

    const ME_QUERY = gql`
        query {
            me {
                token,
                user {
                    id, emailAddress, firstName, lastName
                }
            }
        }
    `;

    const DELETE_MUTATION = gql`
        mutation($id: Guid!) {
            deleteUser(id: $id) {
                token
            }
        }
    `;

    const MY_COMPANIES_QUERY = gql`
        query {
            me {
                companies {
                    id, creationTime, eyeventureUrl, name, websiteUrl
                }
            }
        }
    `;

    export function isOwner(projectId) {
        return client.query({
            query: gql`
                me {
                    user { id },
                    contributingProjects {
                        id,
                        contributors {
                            title,
                            user {
                                id
                            }
                        }
                    }
                }
            `
        }).then(res => {
            let myId = res.me.user.id;
            res.me.contributingProjects.forEach(project => {
                if (project.id == projectId) {
                    if (isOwnerOfProject(myId, project)) {
                        return true;
                    }
                }
            });
        })
    }

    // utility function
    export function isOwnerOfProject(myId, project) {
        let isOwner = false;
        project.contributors.forEach(contributor => {
            if (contributor.title == "Project Owner") {
                if (contributor.user.id == myId) {
                    isOwner = true;
                }
            }
        });
        return isOwner;
    }

    // utility function
    export function isOwnerOfContribution(myId, contribution) {
        return [contribution.contributor.id, contribution.contributor.user.id].includes(myId);
    }

    export function deleteMe() {
        return userInfo().then(res => {
            console.log(res);
            return client.mutate({
                mutation: DELETE_MUTATION,
                variables: {id: res.data.me.user.id}
            });
        })
    }

    export function userInfo() {
        return client.query({
            query: ME_QUERY
        });
    }

    export function companies(refresh) {
        return client.query({
            query: MY_COMPANIES_QUERY,
            fetchPolicy: (refresh) ? "network-only" : "cache-first"
        });
    }

    // use .then() to set token to local storage
    export function getToken() {
        return client.query({
            query: TOKEN_QUERY
        });
    }

</script>